import React, { Component } from 'react';
import { Header, Breadcrumb } from 'semantic-ui-react';
import Messenger from '../../views/components/messenger.js';
import LogTable from './LogTable.jsx';
import LogPageSubHeader from './LogPageSubHeader.jsx';

export default class LogPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      status: this.props.status,
      titleizedStatus: this.props.titleizedStatus,
      log: this.props.log,
    };
    this.eventUpdate = this.eventUpdate.bind(this);
  }

  UNSAFE_componentWillMount() {
    Messenger.on(this.props.channel, this.eventUpdate);
  }

  componentWillUnmount() {
    Messenger.off(this.props.channel, this.eventUpdate);
  }

  eventUpdate(data) {
    const {
      package: { status },
      message: titleizedStatus,
      logs,
    } = data;

    this.setState((prevState) => {
      let newState = {};

      if (prevState.status != status) {
        newState = {
          ...newState,
          status: status,
          titleizedStatus: titleizedStatus,
        };
      }
      if (prevState.log.length !== logs.length) {
        newState.log = logs;
      }
      return newState;
    });
  }

  render() {
    const { log, status, titleizedStatus } = this.state;
    const { packageName, packagePage, packagesPage } = this.props;

    return (
      <div className='package-log-page'>
        <Header as='h2'>Package Log</Header>

        <Breadcrumb
          className='package-breadcrumb'
          size='small'
        >
          <Breadcrumb.Section
            content='Packages'
            href={packagesPage}
          />
          <Breadcrumb.Divider icon='right chevron' />
          <Breadcrumb.Section
            content={packageName}
            href={packagePage}
          />
          <Breadcrumb.Divider icon='right chevron' />
          <Breadcrumb.Section content='Log' />
        </Breadcrumb>

        <LogPageSubHeader
          status={status}
          title={titleizedStatus}
        />

        <LogTable rows={log} />
      </div>
    );
  }
}
